import config from "capacitor.config";
import { SupportedLocale } from "./locale.model";

export const sharedConfig = {
	vivaLiteScanSystemId: 'E61CF419-FD6A-44B9-BF35-C27D4F61B644',
	vivaLiteApplicationId: 'com.alulatechnologies.vitalscore',
	vivaLiteHealthCheckBase: 'https://api.alulahealth.com/health/za/digitalhealthcheck',

	revenueCatIOSKey: 'appl_QBNKwkIRHQEpQqgKbiUbHEyHEvU',
	revenueCatAndroidKey: 'goog_zSlRgdJoylPxGkqfuiGzzbrjiar',
	/** Shen.AI Capacitor SDK API key (native iOS/Android only). */
	shenAiSdkKey: '1ef3226505a1464aa1b61ff7d1b7150a',

	version: '2.947',
	build: 947,
	minimumAge: 18,
	webAppId: config.appId,
	ipInfoToken: 'ab9944c8185245',

	/** Default BCP-47 culture when device/profile cannot be matched. */
	defaultCulture: 'en-ZA',

	/**
	 * Full shared locale catalog. Flavour environment.availablelanguages overrides when present;
	 * if omitted, this list is used. Pack files live at assets/i18n/{culture}.json.
	 */
	availablelanguages: [
		{ culture: 'en-ZA', text: 'English (South Africa)', dir: 'ltr' },
		{ culture: 'en-GB', text: 'English (United Kingdom)', dir: 'ltr' },
		{ culture: 'en-US', text: 'English (United States)', dir: 'ltr' },
		{ culture: 'nl-NL', text: 'Nederlands', dir: 'ltr' },
		{ culture: 'af-ZA', text: 'Afrikaans', dir: 'ltr' },
		{ culture: 'it-IT', text: 'Italiano', dir: 'ltr' },
		{ culture: 'ur-PK', text: 'اردو', dir: 'rtl' },
		{ culture: 'de-DE', text: 'Deutsch', dir: 'ltr' },
		{ culture: 'fr-FR', text: 'Français', dir: 'ltr' },
		{ culture: 'es-ES', text: 'Español (España)', dir: 'ltr' },
		{ culture: 'es-MX', text: 'Español (México)', dir: 'ltr' },
	] as SupportedLocale[],

	imperialCountries: ['us', 'gb', 'lr', 'mm'],

};
